<template>
  <img v-if="fullUrl" :src="fullUrl" :style="style" :width="width" />
</template>

<script>
const ChannelTypeSquareImgUrls = {
  1: 'https://lh3.googleusercontent.com/tsZsYv313q_3iQf6ywMBdKNIPMdCdAtfodOSyR5wVFTOXDkCEowpUQQ2cauJin-VEjmbqjzHT90GT8KC5W0q87ssCuy7tbAY', // Shopee
  2: 'https://lh3.googleusercontent.com/av4idVXx_sebBvaW3s3UmDCmwT_qnbMJwOKXtbmlJTViFiDHmq8HvoVCwSVgmgtoEgSBuHFW5Aj4wC-TF_MBlgEbbBReT4X-mA', // Lazada
}
const ChannelTypeLargeImgUrls = {
  1: 'https://lh3.googleusercontent.com/2TVq2jtQo6503S7JQG_gUIyf_S-FB7fyyrkGsdZoARtZy36WJCf52MDPBmbL_sFhRBFkDMeeeszr__VNqtCG8MZK1AwxUVzE', // Shopee
  2: 'https://lh3.googleusercontent.com/Bmjz8d9zSiyefrvbxf_DW0yaeEOpE-PCXs5rTyMSic-173eEeO8e8Wy2rNyme-XpbKiD-sTcy4LvPXJZR9tAv9YeQYYZD5tPQQ', // Lazada
}

export default {
  props: {
    channelType: {
      type: Number,
      required: true,
      default: 1,
    },
    width: {
      type: Number,
    },
    isLarge: {
      type: Boolean,
    },
    borderRadius: {
      type: Number,
      default: 0,
    }
  },
  computed: {
    /** @return {string} */
    baseUrl() {
      if (this.isLarge) {
        return ChannelTypeLargeImgUrls[this.channelType]
      }
      return ChannelTypeSquareImgUrls[this.channelType]
    },
    /** @return {string} */
    fullUrl() {
      if (!this.baseUrl) {
        return ''
      }
      if (!this.width) {
        return this.baseUrl
      }
      return this.baseUrl + '=w' + Math.round(this.width * window.devicePixelRatio)
    },
    /** @return {any} */
    style() {
      if (this.borderRadius) {
        return {
          borderRadius: this.borderRadius + 'px'
        }
      }
      return undefined
    }
  }
}
</script>